"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrganizationProfile = instanceOfOrganizationProfile;
exports.OrganizationProfileFromJSON = OrganizationProfileFromJSON;
exports.OrganizationProfileFromJSONTyped = OrganizationProfileFromJSONTyped;
exports.OrganizationProfileToJSON = OrganizationProfileToJSON;
exports.OrganizationProfileToJSONTyped = OrganizationProfileToJSONTyped;
var Ace_1 = require("./Ace");
var Organization_1 = require("./Organization");
var CmsPageRevisionResourceLocale_1 = require("./CmsPageRevisionResourceLocale");
/**
 * Check if a given object implements the OrganizationProfile interface.
 */
function instanceOfOrganizationProfile(value) {
    if (!('organization' in value) || value['organization'] === undefined)
        return false;
    return true;
}
function OrganizationProfileFromJSON(json) {
    return OrganizationProfileFromJSONTyped(json, false);
}
function OrganizationProfileFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'version': json['version'] == null ? undefined : json['version'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateModified': json['dateModified'] == null ? undefined : (new Date(json['dateModified'])),
        'owner': json['owner'] == null ? undefined : json['owner'],
        'aces': json['aces'] == null ? undefined : (json['aces'].map(Ace_1.AceFromJSON)),
        'acesInheriting': json['acesInheriting'] == null ? undefined : json['acesInheriting'],
        'organization': (0, Organization_1.OrganizationFromJSON)(json['organization']),
        'storageUrl': json['storageUrl'] == null ? undefined : json['storageUrl'],
        'primaryProduct': json['primaryProduct'] == null ? undefined : json['primaryProduct'],
        'primaryDonationOffer': json['primaryDonationOffer'] == null ? undefined : json['primaryDonationOffer'],
        'primaryDiscordInviteUrl': json['primaryDiscordInviteUrl'] == null ? undefined : json['primaryDiscordInviteUrl'],
        'locale': json['locale'] == null ? undefined : (0, CmsPageRevisionResourceLocale_1.CmsPageRevisionResourceLocaleFromJSON)(json['locale']),
        'illegal': json['illegal'] == null ? undefined : json['illegal'],
    };
}
function OrganizationProfileToJSON(json) {
    return OrganizationProfileToJSONTyped(json, false);
}
function OrganizationProfileToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'version': value['version'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateModified': value['dateModified'] == null ? undefined : ((value['dateModified']).toISOString()),
        'owner': value['owner'],
        'aces': value['aces'] == null ? undefined : (value['aces'].map(Ace_1.AceToJSON)),
        'acesInheriting': value['acesInheriting'],
        'organization': (0, Organization_1.OrganizationToJSON)(value['organization']),
        'storageUrl': value['storageUrl'],
        'primaryProduct': value['primaryProduct'],
        'primaryDonationOffer': value['primaryDonationOffer'],
        'primaryDiscordInviteUrl': value['primaryDiscordInviteUrl'],
        'locale': (0, CmsPageRevisionResourceLocale_1.CmsPageRevisionResourceLocaleToJSON)(value['locale']),
        'illegal': value['illegal'],
    };
}
